<template>
<div>
  1ndex
</div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      
    }
  },
  created(){
    
  }
}
</script>

<style scoped lang="less">


</style>
